<template>
  <group-card
    title="Land Title Search Result"
    icon="fact_check"
    v-if="landTitleFetchResults && landTitleFetchResults.length > 0"
  >
    <div v-if="this.landTitleFetchResults.some(
      (result) => result && result.state_territory_land_registry)">
      <div class="md-layout boxed-category"
        v-for="(land_title, key) in landTitleFetchResults">
        <div class="md-layout-item md-size-80">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <property-view right name="State Terrirory Land Registry" width="100%">
                {{ land_title.state_territory_land_registry }}
              </property-view>
            </div>
            <div class="md-layout-item md-size-100">
              <property-view right name="Title Reference" width="100%">
                {{ land_title.title_reference }}
              </property-view>
            </div>
            <div class="md-layout-item md-size-100">
              <property-view right name="Title Description" width="100%">
                {{ land_title.title_description }}
              </property-view>
            </div>
          </div>
        </div>
        <div class="md-layout-item md-size-20 button-container">
          <loading-icon-text-button
            class="md-primary md-sm"
            @click="select_land_title(land_title, key)"
            icon="search"
            :disabled="isDisabled(key)"
            :loading="loading_land_title_id === key">
            Request Title
          </loading-icon-text-button>
        </div>
      </div>
      <md-snackbar :md-active.sync="snackbar.show" :md-duration="8000">
        <span>
          <template v-if="snackbar.icon">
            <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
            &nbsp;&nbsp;&nbsp;
          </template>
          {{ snackbar.content }}
        </span>
      </md-snackbar>
    </div>
    <div v-else>
      <p class="no-results-message">
        No results found for current address.
      </p>
    </div>
    </group-card>
</template>

<script>
import GroupCard from '@/components/Cards/GroupCard';
import GroupCardRow from '@/components/Cards/GroupCardRow';
import PropertyView from '@/components/ApplicationSummary/PropertyView';
import {mapGetters} from "vuex";
import LoadingIconTextButton from "../LoadingIconTextButton.vue";
import ConfirmDialog from "../Dialogs/ConfirmDialog";
export default {
  data() {
    return {
      loading_land_title_id: null,
      snackbar: {
        show: false,
        icon: 'done',
        content: '',
      },
    }
  },
  props: {
    landTitleFetchResults: {
      type: Array,
      default: null,
    },
    applicationId: {
      type: Number,
      required: true,
    },
    applicantId: {
      type: Number,
      required: true,
    },
  },
  components: {
    LoadingIconTextButton,
    GroupCard,
    GroupCardRow,
    PropertyView,
  },
  methods: {
    async select_land_title(landTitle, key, requestEvenDelivered = false) {
      try {
        this.loading_land_title_id = key;
        let result = await this.$store.dispatch(
          'request_land_title_document', {
            landTitle: landTitle,
            applicationId: this.applicationId,
            applicantId: this.applicantId,
            requestEvenDelivered: requestEvenDelivered,
          });
        if (result.status && result.status === "failed") {
          if (result.message === 'land_title_in_progress') {
            this.$modal.show(ConfirmDialog, {
              title: "Request in Progress",
              important: "Currently processing a land title request. Please check back shortly.",
              confirmText: 'OK',
            });
          } else if (result.message === 'land_title_delivered') {
            const response = await this.$modal.show(ConfirmDialog, {
              title: "Confirm",
              important: "A successful land title request has been completed for this application. This will request another land title and may incur an additional charge. Continue?",
              confirmText: 'CONFIRM',
              cancelText: 'CANCEL',
            })
            if (response) {
              return this.select_land_title(landTitle, key, true);
            }
          }
        }
        if (result === true) {
          this.snackbar.content = 'Land Title document requested successfully.';
          this.snackbar.icon = 'done';
          this.snackbar.show = true;
        }
      } catch (error) {
        this.snackbar.content = error;
        this.snackbar.icon = 'error';
        this.snackbar.show = true;
      }
      this.loading_land_title_id = null;
    },
    isDisabled(key) {
      if(key === this.loading_land_title_id && this.loading_land_title_id !== null) {
        return true;
      }
    },
  },
}
</script>

<style scoped>

</style>
